{
  "en": {
    "task_assignment": {
      "actions": {
        "add_assignee": "Add an assignee",
        "bulk_remove": "Remove from task",
        "change_status": "Change status",
        "confirm": "Mark as done",
        "create": "Task",
        "delete": "Delete assignee",
        "due_in_month": "In a month",
        "due_in_two_weeks": "In two weeks",
        "due_in_week": "In one week",
        "due_remove": "Remove deadline",
        "move_to_draft": "Move to draft",
        "reopen": "Reopen",
        "selectAll": "Select all {total}",
        "send_and_notify": "Send and notify",
        "set_due_date": "Set due date",
        "set_status": "Set status",
        "unSelectAll": "Deselect all"
      },
      "assignee_types": {
        "customer": "Customer",
        "employee": "Employee",
        "partner": "Partner"
      },
      "attributes": {
        "assignee": "Assignee",
        "assignees": "Assignees",
        "comment": "Comment",
        "created_at": "Created",
        "document": "Document",
        "due_date": "Due date",
        "project": "Project",
        "status": "Status",
        "task": "Task",
        "unit": "Unit"
      },
      "confirm": {
        "affected": "This affects {customers} and {team}.",
        "affected_customers": "This affects {customers}.",
        "affected_team": "This affects {team}.",
        "bulk_affected": "This writes {count} assignment. | This writes {count} assignments.",
        "bulk_delete_body": "The task stays, on this unit and on every other one. Only the rows you selected go.",
        "bulk_delete_header": "Remove these assignments?",
        "complete_body": "Their tasks are closed for them and disappear from their list, even if they never acted.",
        "complete_header": "Close this task for everyone?",
        "customer_tasks": "{count} customer task | {count} customer tasks",
        "delete_body": "Only this one assignment goes. The task keeps its other assignees and its other units.",
        "delete_header": "Delete {name} from this task?",
        "delete_sent_customers": "This one was already sent, so it disappears from the customer portal of {unit} as well.",
        "delete_sent_team": "This one was already sent, so it disappears from the list of {name} as well.",
        "draft_body": "The task disappears until it is sent again. Emails that already went out stay sent.",
        "draft_header": "Move this task back to draft?",
        "send_customers": "Customers see the task in their portal straight away and are notified.",
        "send_header": "Send to the assignees?",
        "send_permanent": "Sending cannot be undone. Moving the task back to draft later does not take the notification back.",
        "send_status": "They land on Requested.",
        "send_team": "Team members are notified.",
        "team_tasks": "{count} team task | {count} team tasks"
      },
      "filters": {
        "due_window_values": {
          "month": "Due within a month",
          "none": "No deadline",
          "overdue": "Overdue",
          "week": "Due within a week"
        },
        "show_only": "Show only",
        "show_only_values": {
          "customers": "Customers",
          "mine": "Assigned to me",
          "team": "Team"
        }
      },
      "labels": {
        "add_assignee": "Add an assignee…",
        "add_customers": "Add customers",
        "already_assigned": "This task is already added to this unit.",
        "already_assigned_project": "This task is already added to this project.",
        "assignees": "Assignees",
        "comment_earlier": "+{count} earlier",
        "comment_earlier_round": "earlier round",
        "comment_placeholder": "e.g. the meter was hard to reach, this is the best photo I could get",
        "comments_none": "The customer left no comment.",
        "comments_title": "Comments on this task",
        "completed": "Completed",
        "confirm_message": "Are you sure you want to mark this task as done?",
        "customers": "Customers",
        "my_tasks": "My tasks",
        "no_assignees": "No assignees yet.",
        "no_assignments": "No tasks yet.",
        "no_assignments_task": "No assignments for this task yet.",
        "no_assignments_unit": "No tasks for this unit yet.",
        "required": "This field is required",
        "selectOne": "Select at least one assignment.",
        "select_task": "Select a task",
        "selected": "{selected} selected | {selected} selected",
        "set_status_for": "Set status for {name}",
        "totalSelected": "All {total} selected",
        "upload_hint": "Upload the requested document(s) to complete this task.",
        "uploaded_documents": "Uploaded documents"
      },
      "statuses": {
        "completed": "Completed",
        "draft": "Draft",
        "requested": "Requested"
      },
      "toasts": {
        "bulk_delete": "Assignments removed",
        "bulk_update": "Assignments updated",
        "completed": "Task completed",
        "create": "Task created",
        "delete": "Assignee deleted",
        "reopened": "Task reopened",
        "update": "Task updated"
      }
    }
  }
}
